import { render } from "./ShareSpace.vue?vue&type=template&id=46a283f4"
import script from "./ShareSpace.vue?vue&type=script&lang=js"
export * from "./ShareSpace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__